import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "./Brand";
import { STEPS } from "../../lib/data";

export const HowItWorks = () => (
  <section id="como-funciona" data-testid="how-it-works" className="relative py-28 lg:py-40">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>Como funciona</Eyebrow>
            <h2 className="mt-6 font-display font-black uppercase text-white leading-[1] text-4xl md:text-5xl">
              Do clique à <span className="text-gold-grad">garra</span> em 4 passos.
            </h2>
            <p className="mt-6 text-zinc-300 max-w-md text-base md:text-lg">Você só escolhe e reserva. O resto — transporte, montagem e monitor — é com a gente.</p>
          </Reveal>
          <Reveal delay={0.15} className="mt-10 hidden sm:block">
            <div className="relative h-[300px] rounded-[28px] overflow-hidden border border-white/10 [clip-path:polygon(0_0,100%_0,100%_85%,85%_100%,0_100%)]">
              <img src="/media/plush-machine.jpg" alt="Pelúcias dentro da máquina" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#08080C]/70 to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
      <ol className="lg:col-span-7 lg:pl-10">
        {STEPS.map((s, i) => (
          <motion.li key={s.n} data-testid={`step-${s.n}`}
            initial={{ opacity: 0, x: 40 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
            className="group grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-10 border-b border-white/10 first:border-t">
            <span className="font-display font-black text-5xl md:text-7xl text-stroke group-hover:text-[#FFD200] transition-colors duration-500 leading-none">{s.n}</span>
            <div>
              <h3 className="font-display font-bold text-xl md:text-2xl text-white">{s.title}</h3>
              <p className="mt-3 text-zinc-300 leading-relaxed max-w-lg">{s.text}</p>
            </div>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
